import * as z from "zod";

export const getActiveTextConciergeMerchants = {
  name: "getActiveTextConciergeMerchants" as const,
  // Returns every concierge-enabled brand with its metrics over [start, end].
  // Search, sort, and pagination are done client-side so those interactions
  // don't re-run the (fleet-wide) per-brand analytics queries.
  input: z.object({ start: z.date(), end: z.date() }),
  output: z.object({
    merchants: z.array(
      z.object({
        teamId: z.string(),
        teamName: z.string(),
        recoverEnabled: z.boolean(),
        analyticsSource: z.enum(["v1_snowflake", "v2_opensearch"]),
        // Per-brand metrics over [start, end]; the client derives reply rate
        // and escalation rate from these.
        outboundMessages: z.number(),
        customerReplies: z.number(),
        uniqueRecipients: z.number(),
        conversationsWithReply: z.number(),
        escalatedConversations: z.number(),
      }),
    ),
  }),
};
